
import voltx from "../assets/voltx.png"
import design from "../assets/design.png"
import systeme from "../assets/systeme.png"
import composite from "../assets/composite.png"
import usine from "../assets/usine.png"
import plate from "../assets/plate.png"


const caseStudiesContent = {
    STRATEGIE: {
      title: "LA SÉRIE VOLT-X",
      description: "Notre gamme phare de véhicules électriques combine performance exceptionnelle et technologie de pointe. La série VOLT-X représente une redéfinition complète de la mobilité urbaine, alliant design avant-gardiste et innovation technologique.",
      image: voltx
    },
    DESIGN: {
      title: "DESIGN AÉRODYNAMIQUE",
      description: "Notre approche du design automobile redéfinit les standards de l'aérodynamisme. Chaque courbe est optimisée pour maximiser l'efficacité énergétique tout en créant une signature visuelle distinctive.",
      image: design
    },
    INGENIERIE: {
      title: "SYSTÈME DE PROPULSION",
      description: "Une innovation majeure dans la technologie des moteurs électriques. Notre système de propulsion nouvelle génération offre un équilibre parfait entre puissance et efficacité.",
      image: systeme
    },
    MATERIAUX: {
      title: "COMPOSITE AVANCÉ",
      description: "Développement de matériaux composites ultra-légers et durables. Nos recherches en science des matériaux permettent de réduire le poids tout en augmentant la sécurité.",
      image: composite
    },
    PLATEFORMES: {
      title: "PLATEFORME MODULAIRE",
      description: "Une architecture véhicule innovante et adaptable. Notre plateforme modulaire permet une flexibilité maximale dans le développement de nouveaux modèles.",
      image: plate
    },
    INDUSTRIALISATION: {
      title: "USINE 4.0",
      description: "Notre processus de fabrication intelligent utilise les dernières technologies d'automatisation et d'IA pour une production optimale et durable.",
      image: usine
    }
  };


  export default caseStudiesContent ; 



